<p-table stripedRows #dataTable [value]="items" selectionMode="single" [style]="{ width: '100%', 'min-width': '110em' }"
    scrollHeight="flex" [scrollable]="true" editMode="row" dataKey="ContractListID" (onRowSelect)="onRowSelect($event)"
    [(selection)]="selected">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <!-- edit -->
            <th class="edit-cell"></th>
            <!-- status -->
            <th class="status-cell">
                <i class="pi pi-exclamation-circle" title="Status"></i>
            </th>
            <!-- ContractDesc -->
            <th pSortableColumn="ContractDesc">
                Contract
                <p-sortIcon field="ContractDesc" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="ContractListID" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect class="filter" defaultLabel="Filter" [options]="contractSelectItems"
                            [filter]="true" appendTo="body" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Invoice Cycle -->
            <th pSortableColumn="InvoiceCycle">
                Invoice Cycle
                <p-sortIcon field="InvoiceCycle" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="InvoiceCycle" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect class="filter" defaultLabel="Filter" [options]="icSelectItem" [filter]="true"
                            appendTo="body" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Invoice Day -->
            <th pSortableColumn="InvoiceCycleDay">
                Invoice Day
                <p-sortIcon field="InvoiceCycleDay" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="InvoiceCycleDay" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect class="filter" defaultLabel="Filter" [options]="icdSelectItem" [filter]="true"
                            appendTo="body" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Invoice Day 2 -->
            <th *ngIf="this.hasInvoiceCycle24 == true" pSortableColumn="InvoiceCycleDay2">
                Invoice Day 2
                <p-sortIcon field="InvoiceCycleDay2" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="InvoiceCycleDay2" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect class="filter" defaultLabel="Filter" [options]="icd2SelectItem" [filter]="true"
                            appendTo="body" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- First Invoice Start Date -->
            <th pSortableColumn="FirstInvoiceStartDate" title="Enter start date of first invoice period">
                1st Invoice Start Date
                <p-sortIcon field="FirstInvoiceStartDate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Cycle Effective Date -->
            <th pSortableColumn="CycleEffectiveDate" title="Enter end date of first invoice period">
                1st Invoice End Date
                <p-sortIcon field="CycleEffectiveDate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Contract Start Date -->
            <th pSortableColumn="ContractStartDate">
                Contract Start Date
                <p-sortIcon field="ContractStartDate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Contract End Date -->
            <th pSortableColumn="ContractEndDate">
                Contract End Date
                <p-sortIcon field="ContractEndDate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Modified Date -->
            <th pSortableColumn="ModifiedDate">
                Modified Date
                <p-sortIcon field="ModifiedDate" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- reset -->
            <th>
                Rebuild Schedule
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-contract let-rowData let-edit="editing">
        <tr [pEditableRow]="contract" [pSelectableRow]="contract" data-id="row-1-{{ contract.ContractListID }}">
            <!-- edit -->
            <td class="edit-cell">
                <button title="Edit" *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === contract?.id) &&
                        contract.IsActive == true
                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                    (click)="onRowEditInit(rowData)" class="p-button-rounded p-button-text" title="Edit"></button>
                <button title="Save" *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                    (click)="onRowEditSave(rowData)" class="p-button-rounded p-button-text p-button-success"></button>
                <button title="Cancel" *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                    (click)="onRowEditCancel(rowData)" class="p-button-rounded p-button-text p-button-danger"></button>
            </td>
            <!-- status -->
            <td class="status-cell">
                <div (click)="onStatusClick(contract)" class="status-cell">
                    <ef-status-icon [status]="contract?.Status?.StatusCode"
                        [message]="contract?.Status?.Message"></ef-status-icon>
                </div>
            </td>
            <!-- ContractDesc -->
            <td>
                <label [title]="contract.ContractDesc">{{
                    contract.ContractDesc
                    }}</label>
            </td>
            <!-- Invoice Cycle -->
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div *ngIf="u_contractSelectItems as items">
                            <p-select [options]="items" [(ngModel)]="contract.InvoiceCycle"
                                [filter]="false" appendTo="body" [autoDisplayFirst]="false"
                                (onChange)="invoiceCycleValueChanged($event)">
                            </p-select>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ contract.InvoiceCycle }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Invoice Day -->
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div *ngIf="invoiceCycleDaysSelectItems as items">
                            <p-select [options]="items" [filter]="false" appendTo="body"
                                [autoDisplayFirst]="false" [(ngModel)]="contract.InvoiceCycleDay">
                            </p-select>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div *ngIf="contract.InvoiceCycleDay != null">
                            {{ this.findInvoiceDayDesc(contract) }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Invoice Day 2 -->
            <td *ngIf="this.hasInvoiceCycle24 == true">
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div *ngIf="
                                contract.InvoiceCycleDay2 != null &&
                                invoiceCycle24Selected == false
                            ">
                            {{ this.findInvoiceDay2Desc(contract) }}
                        </div>
                        <div *ngIf="invoiceCycle24Selected == true">
                            <div *ngIf="contractSelectItemsD2 as items">
                                <p-select [options]="items" [virtualScroll]="true" [filter]="false" appendTo="body"
                                    [autoDisplayFirst]="false" [(ngModel)]="contract.InvoiceCycleDay2">
                                </p-select>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div *ngIf="contract.InvoiceCycleDay2 != null">
                            {{ this.findInvoiceDay2Desc(contract) }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- First Invoice Start Date -->
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div>
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="2000:2030" [(ngModel)]="contract.FirstInvoiceStartDate"
                                [maxDate]="contract.ContractEndDate"></p-calendar>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <span *ngIf="contract.FirstInvoiceStartDate != null"
                        >
                            {{
                            moment(contract.FirstInvoiceStartDate).format(
                            'MM/DD/YYYY'
                            )
                            }}
                        </span>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Cycle Effective Date -->
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div>
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="2000:2030" [(ngModel)]="contract.CycleEffectiveDate"
                                [maxDate]="contract.ContractEndDate"></p-calendar>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <span *ngIf="contract.CycleEffectiveDate != null"
                            title="The invoice cycle will start on /or after this date.">
                            {{
                            moment(contract.CycleEffectiveDate).format(
                            'MM/DD/YYYY'
                            )
                            }}
                        </span>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Contract Start Date -->
            <td>
                <span *ngIf="contract.ContractStartDate != null">
                    {{
                    moment(contract.ContractStartDate).format(
                    'MM/DD/YYYY'
                    )
                    }}
                </span>
            </td>
            <!-- Contract End Date -->
            <td [title]="endDateTooltip" [class.alert]="lessThanToday(contract.ContractEndDate)">
                <span *ngIf="contract.ContractEndDate != null">
                    {{
                    moment(contract.ContractEndDate).format(
                    'MM/DD/YYYY'
                    )
                    }}
                </span>
                <!-- <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div>
                            <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="2000:2030" [(ngModel)]="contract.ContractEndDate"></p-calendar>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <span *ngIf="contract.ContractEndDate != null">
                            {{
                            moment(contract.ContractEndDate).format(
                            'MM/DD/YYYY'
                            )
                            }}
                        </span>
                    </ng-template>
                </p-cellEditor> -->
            </td>
            <!-- Modified Date -->
            <td [title]="endDateTooltip">
                <span *ngIf="contract.ModifiedDate != null">
                    {{ moment(contract.ModifiedDate).format('MM/DD/YYYY') }}
                </span>
            </td>
            <!-- reset -->
            <td class="delete-cell">
                <button pButton pRipple icon="pi pi-refresh"
                    title="Rebuild the contract invoice schedule for periods that have not been processed." (click)="
                        this.selected = contract;
                        ResetContract.next(contract.ContractListID)
                    " type="button" severity="info" text rounded></button>
            </td>
        </tr>
    </ng-template>
</p-table>
